import { Box, Typography } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	PhoneNumberRHF,
	PostCodeRHF,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { formatNumberToMaximumTenCharacters, sortDDLByLabel } from "../../../common/Common";

import { AuthService } from "../../../services";
import { CityService } from "../../../services/CityService";
import { CountryService } from "../../../services/common/CountryService";
import { useQuery } from "@tanstack/react-query";

interface INewAcocuntSetupFieldsPanel {
	formMethods: any;
	countryList: any;
	isLoadingData: (value: boolean) => void
	setDefaultSelectedCountry: (value: any) => void
	companySequenceNumber: any

	provinceStateDDLinUpdate: any;
	provinceStateLabelinUpdate: any;
	cityDDLinUpdate: any;
}
export const NewAcocuntSetupFieldsPanel: FC<
	INewAcocuntSetupFieldsPanel
> = ({ formMethods, countryList, isLoadingData, companySequenceNumber,
	setDefaultSelectedCountry,
	provinceStateDDLinUpdate,
	provinceStateLabelinUpdate,
	cityDDLinUpdate,
}) => {
		const [provinceOrStateDDL, setprovinceOrStateDDL] = useState(undefined);
		const [cityDDL, setCityDDL] = useState(undefined);
		const [countrytype, setCountrytype] = useState("Province");
		const [selectedCountryShortCode, setSelectedCountryShortCode] = useState("");
		const [selectedCountry, setSelectedCountry] = useState<any>("");
		const onCountryChangeHandler = async (e: any) => {
			setSelectedCountryShortCode(e.shortCode);
			setDefaultSelectedCountry(e.value);
			setSelectedCountry(e.value);
			let selected = e.value;
			setCountrytype(
				e.countryType === "province"
					? "Province"
					: e.countryType === "state"
						? "State"
						: e.countryType
			);
			formMethods.setValue("province", undefined);
			formMethods.setValue("state", undefined);
			try {
				isLoadingData(true);
				const responce = await AuthService.getProvinceOrStateDDL(
					selected,
					e.countryType
				);
				setprovinceOrStateDDL(responce);
			} catch {
			} finally {
				isLoadingData(false);
			}
		};

		const onProvinceChangeHandler = async (e: any) => {
			let selected = e.value;
			formMethods.setValue("city", undefined);
			try {
				isLoadingData(true);
				const responce = await AuthService.getCityDDL(selected);
				setCityDDL(responce);
			} catch {
			} finally {
				isLoadingData(false);
			}
		};

		useEffect(() => {
			if (provinceStateDDLinUpdate && provinceStateLabelinUpdate) {

				setprovinceOrStateDDL(provinceStateDDLinUpdate);
				setCountrytype(
					provinceStateLabelinUpdate === "province"
						? "Province"
						: provinceStateLabelinUpdate === "state"
							? "State"
							: provinceStateLabelinUpdate
				);
				setSelectedCountryShortCode(
					provinceStateLabelinUpdate === "province"
						? "CAN"
						: provinceStateLabelinUpdate === "state"
							? "USA"
							: provinceStateLabelinUpdate
				);
			}
			if (cityDDLinUpdate) {
				setCityDDL(cityDDLinUpdate);
			}
			if (countryList && Array.isArray(countryList)) {
				const canada = countryList.find(
					(item: any) => item.label === "Canada" || "canada"
				);
				if (canada) {
					setSelectedCountry(canada.value);
					setDefaultSelectedCountry(canada.value);
					setSelectedCountryShortCode(canada.shortCode ? canada.shortCode : "");
					(async () => {
						try {
							const response = await AuthService.getProvinceOrStateDDL(
								canada.value,
								"Province"
							);
							setprovinceOrStateDDL(response);
							//   provinceDDLItems(response);
						} catch (err) {
							console.error("error", err);
						}
					})();
				}
			}
		}, [
			provinceStateLabelinUpdate,
			provinceStateDDLinUpdate,
			countryList,
			cityDDLinUpdate,
		]);
		return (
			<Box>
				<Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px", display: "flex", justifyContent: "space-between" }}>
					<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
						Company Account No.
					</Typography>
					<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
						SP {formatNumberToMaximumTenCharacters(companySequenceNumber)}
					</Typography>
				</Box>
				<RHookFormTextFieldWithLabel
					label="Legal Name"
					id="legalName"
					testId={`legal-Name`}
				/>
				<RHookFormTextFieldWithLabel
					label="Operating Name"
					id="operatingName"
					testId={`Operating-Name`}
					placeholder="If different from legal name"
				/>
				<RHookFormTextFieldWithLabel
					label="Address"
					id="addressLine1"
					testId={`accountant-addressLine1`}
				/>
				{countryList && selectedCountry && (
					<EnhancedDropDownRHFWithLabel
						selectName="country"
						label="Country"
						testId={`country-list`}
						items={countryList ?? []}
						selectedItem={selectedCountry}
						onSelectionChangeHandler={onCountryChangeHandler}
					/>
				)}
				{provinceOrStateDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"province"}
						label={countrytype}
						testId={`province-list`}
						items={provinceOrStateDDL ?? []}
						onSelectionChangeHandler={onProvinceChangeHandler}
					/>
				)}
				{provinceOrStateDDL && cityDDL && (
					<EnhancedDropDownRHFWithLabel
						selectName={"city"}
						label={"City"}
						testId={`city-list`}
						items={cityDDL && sortDDLByLabel(cityDDL ?? [])}
					/>
				)}
				{selectedCountryShortCode === "CAN" ? (
					<PostCodeRHF
						label="Post Code"
						id="postCode"
						testId={`accountant-post-code`}
					/>
				) : selectedCountryShortCode === "USA" ? (
					<RHookFormMaskedTextFieldWithLabel
						label="Zip Code"
						id="zipCode"
						testId={`Zip-Code`}
						placeholder={"00000"}
						inputMaskPattern={"00000"}
					/>
				) : (
					<></>
				)}
				<PhoneNumberRHF
					id="phone"
					label="Phone"
					testId="phoneNumber"
				/>
				<RHookFormMaskedTextFieldWithLabel
					id="craBusinessNo"
					label="Business #"
					testId="Business No."
					placeholder={"000000000RP0000"}
					inputMaskPattern={"{000000000RP0000}"}
				/>


				{/* <Grid
				container
				columnSpacing={0}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
					<RHookFormMaskedTextFieldWithLabel
						id="craBusinessNo"
						label="Business #"
						testId="Business No."
						placeholder={"000000000RP0000"}
						inputMaskPattern={"{000000000RP0000}"}
					/>
				</Grid>
				<Grid
					size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
				></Grid>
				<Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
					<ExtensionNumberRHF
						label="RP"
						id="ext"
						testId={`ext`}
					/>
				</Grid>
			</Grid> */}

				<RHookFormDatePicker
					name="scheduleStartDate"
					testId="Schedule Start Date"
					label="Schedule Start Date"
					format="M dd, yy"
				/>

			</Box>
		);
	};
